<template lang="pug">
  .component-tabbed-client-credit-note
    .row
      .columns.p-3
        RefundableRecords(@select="mapRecords", :data-loader="dataLoader", :selected="selected").text-center
        template(v-for="(record,index) in body.records")
          .row
            .columns
              BackofficeWalletRecord(:item="findRecord(record.id)", type="multi-wallet")
            .columns
              label Type
                .help-text(v-if="body.records[index].type === 'EXACT_AMOUNT'") Amount should have be billed
                .help-text(v-if="body.records[index].type === 'DISCOUNT'") Discount paid amount
                select(v-model="body.records[index].type")
                  option(value="EXACT_AMOUNT") Exact amount
                  option(value="DISCOUNT") Discount

              label Amount vat included
                input(v-model="body.records[index].amount", type='number' min="0", @input="checkValue($event, record.id)")
              .row.text-center
                .column(v-for="(value, key) in getRecordAmount(body.records[index])" )
                  label {{key.replace("_", " ")}}
                  h2 {{$priceWithcurrency(value)}}
              .row(v-if="findRecord(record.id).invoice.document_total === 0" )
                .column
                  h3.text-center Can be only refunded as PAID credit
          hr

        template(v-if="Object.keys(body.records).length").mr-3
          .row
            .column.large-4
              label Reason
                input(type="text", v-model="body.reason")
              label Emit as PROFORMA
                input(type="checkbox", v-model="body.emit_as_proforma", @change="body.emit_as_proforma ? body.refund_on_gateway = false : body.emit_as_proforma")
              label Refund on gateway
                input(type="checkbox", v-model="body.refund_on_gateway", :disabled="body.emit_as_proforma")
            .column.text-right.mr-3
              h2 Total amount: {{$priceWithcurrency(getSummary.toFixed(2))}}

              ActionButton(:action="emit", :confirm="true") Emit&nbsp;
                span(v-if="body.emit_as_proforma" ) as Proforma
                span(v-else) as Credit note


</template>
<script type="text/babel">
import InvoiceListForm from '../../structure/ui/filters/InvoiceListForm'
import BaseList from '../../../pages/backoffice/BaseList'
import HeaderColumns from '../../structure/ui/HeaderColumns'
import ActionBar from '../../structure/ui/ActionBar'
import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
import RefundableRecords from "../../structure/ui/actions/reveal/RefundableWalletRecords.vue";
import BackofficeWalletRecord from "../WalletRecord.vue";
import Card from "../../structure/Card.vue";
import ActionButton from "../../structure/ui/ActionButton.vue";

export default {
  name: 'TabbedClientInvoices',
  components: {
    ActionButton,
    Card,
    BackofficeWalletRecord,
    RefundableRecords,
    ActionBar,
    HeaderColumns,
    BaseList,
    InvoiceListForm,
  },
  data() {
    return {
      selected: [],
      refundable: [],
      items: [],
      component: require('src/components/backoffice/WalletRecord.vue'),
      body: {
        records: {},
        refund_on_gateway: false,
        emit_as_proforma: true,
        reason: null
      },
    }
  },
  created() {
    this.dataLoader(() => null, 1, 5)
  },
  methods: {
    emit() {
      return KeplerBackofficeSdk.wallets.select(this.$route.params.wallet_id).manualCreditNote(this.body, (data) => {
        this.$router.push({name: 'invoice', params: {id: data.id}})
      })
    },
    dataLoader(callback, page, resultsPerPage, search) {

      KeplerBackofficeSdk.wallets.list(page, resultsPerPage).refundable(this.$route.params.wallet_id, search, (data) => {
        callback(data)
        //this.refundable = data.items
        data.items.forEach((item) => {
          if (this.items.findIndex(x => x.id === item.id) === -1) {
            this.items.push(item)
            this.refundable.push(item)
          }
        })
      })

    },
    findRecord(recordId) {
      return this.items.filter((item) => item.id === recordId)[0]
    },
    convertArrayToObject(array, key) {
      const initialValue = {};
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item,
        };
      }, initialValue);
    },
    mapRecords(input) {
      this.body.records = this.convertArrayToObject(this.refundable.filter((item) => {
        return input.includes(`${item.id}`)
      }).map((item) => {

        const amount = this.body.records[item.id] !== undefined && this.body.records[item.id].hasOwnProperty('amount') ? this.body.records[item.id].amount : null
        const type = this.body.records[item.id] !== undefined && this.body.records[item.id].hasOwnProperty('type') ? this.body.records[item.id].type : 'DISCOUNT'
        return {amount: amount, type: type, id: item.id}
      }), 'id')

    },
    checkValue(event, recordId) {
      const record = this.findRecord(recordId)
      const total = Math.abs((record.amount) + (record.amount * -record.tax))
      if (parseFloat(this.body.records[record.id].amount) > total) {
        this.body.records[record.id].amount = total.toFixed(2)
      }
      if (parseFloat(this.body.records[record.id].amount) < 0) {
        this.body.records[record.id].amount = 0
      }
    },
    getRecordAmount(record) {

      if (record.amount === null) {
        return {}
      }
      const original = this.findRecord(record.id)
      const originalAmount = Math.abs(this.$priceWithVat(original.amount, original.target))


      let result = {
        correct_amount: null,
        give_back: null,
      }

      switch (record.type) {
        case 'DISCOUNT':
          result.correct_amount = ((Math.abs(originalAmount - record.amount)).toFixed(2))
          result.give_back = (record.amount)

          break
        case 'EXACT_AMOUNT':
          result.correct_amount = (Math.abs(record.amount))
          result.give_back = ((originalAmount - record.amount).toFixed(2))
          break
      }

      return result
    },

  },
  computed: {
    getSummary() {
      let giveBack = 0
      for (const key in this.body.records) {
        const record = this.body.records[key]
        if (record.amount !== null) {
          giveBack += Math.abs(this.getRecordAmount(record).give_back)
        }
      }
      return giveBack
    },
    records() {
      return this.convertArrayToObject(this.refundable, 'id')
    }
  },
  props: [],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-tabbed-client-credit-note
  .flex-list
    input[type=checkbox]
      margin-right: 2em !important

  .component-invoice-list-filter-form
    select
      padding: 0
      background-position: right 0 center
      height: auto
</style>



// WEBPACK FOOTER //
// ClientCreditNote.vue?0d96fe9c